







































































import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import {getToday, addMonth} from '@/utils/dateUtils';
@Component({
  components: {
    PageTitle,
    RadioElement,
    DateCalendar
  }
})
export default class ProhibitMember extends Vue {
  private request: any = {
    reason: '',
    notificationMessage: '',
    memberNos: [],
    prohibition: true,
    expireDate: '',
    notificationMethod: null,
    status: 'PAUSED'
  };

  private targetMembers: string = '';
  private stopUsingsayo: string = '';
  private validPeriod: string = '';
  private placeholderValue: string = '';
  private stopUsing: any = {
    name: 'stopUsing',
    data: [
      {
        id: 'stop1',
        value: 'STOP_USING',
        dispaly: this.$t('MEMBER_POPUP_DATA_DISPLAY_STOP_USING')
      },
      {
        id: 'stop2',
        value: 'RELIEVE_STOP',
        dispaly: this.$t('MEMBER_POPUP_DATA_DISPLAY_RELIEVE_STOP')
      }
    ]
  };
  private stopValue: string = 'STOP_USING';

  private stopDateValue: string = 'STOP_DATE';

  private stopUsingNotice: any = {
    name: 'stopUsingNotice',
    data: [
      {
        id: 'email',
        value: 'EMAIL',
        dispaly: this.$t('MEMBER_POPUP_DATA_DISPLAY_E_MAIL')
      },
      {
        id: 'sms',
        value: 'SMS',
        dispaly: 'SMS '
      },
      {
        id: 'sendAll',
        value: 'ALL',
        dispaly: this.$t('MEMBER_POPUP_DATA_DISPLAY_SEND_ALL')
      }
    ]
  };
  private stopUsingNoticeValue: string = 'EMAIL';
  private prohibitDate: any = {};
  private calendarOption = {
    dateType: 'Ymd',
    name: 'prohibtMember',
    fromRanges: getToday(),
    placeholder: ''
  };

  private created(): void {
    let memberNumbers = (this.$route.query.memberNumbers as string).split(',');
    if (memberNumbers.length > 1) {
      this.targetMembers = memberNumbers.length + '명';
    } else {
      let targetMember = sessionStorage.getItem('memberName');
      this.targetMembers = targetMember;
    }
    this.prohibitDate = addMonth(new Date(), 3);
  }
  private successContent: string = '';
  private failContent: string = '';
  private okClick(): any {
     let memberNumbers = (this.$route.query.memberNumbers as string).split(',');
    if (this.stopValue === 'STOP_USING') {
      this.request.prohibition = true;
      this.request.reason = this.stopUsingsayo;
      this.request.notificationMessage = this.placeholderValue;
      this.request.memberNos = memberNumbers;
      this.request.expireDate = this.prohibitDate;
      this.request.notificationMethod = this.stopUsingNoticeValue;
      if (this.stopUsingsayo === '') {
        alert(this.$t('MEMBER_POPUP_ALERT_PLEASE_ENTER_THE_REASON_TO_STOP_USING'));
        return;
      }
      if (this.placeholderValue === '') {
        alert(this.$t('MEMBER_POPUP_ALERT_PLEASE_ENTER_THE_CONTENT_OF_CUSTOMER_NOTIFICATION'));
        return;
      }
    } else {
      this.request.prohibition = false;
      this.request.status = null;
      this.request.memberNos = memberNumbers;
    }
    if (window.confirm(this.$t('MEMBER_POPUP_ALERT_ARE_YOU_SURE_YOU_WANT_TO_STOP_USING_IT') as string)) {
      this.$api.postMemberHibit(this.request).then((res: any) => {
        let successBox = [];
        let failBox = {
          discontinued: [],
          address: [],
          stopped: [],
          email: []
        };
        res.data.rows.map(item => {
          if (item.success) {
            successBox.push(item.memberNo);
          } else {
            switch (item.message) {
              case '이미 이용 정지 중인 회원입니다.':
                failBox.discontinued.push(item.memberNo);
                break;
              case '이메일 주소가 없는 회원입니다.':
                failBox.address.push(item.memberNo);
                break;
              case '이미 이용 정지 중인 회원입니다.':
                failBox.stopped.push(item.memberNo);
                break;
              case '이메일 주소가 없는 회원입니다.':
                failBox.email.push(item.memberNo);
                break;
            }
          }
        });

        if (successBox.length) {
          this.successContent = `성공${successBox.length}건: ${res.data.value} (${successBox.toString()})`;
        }
        if (failBox.discontinued.length || failBox.address.length || failBox.stopped.length || failBox.email.length) {
          this.failContent = `실패${failBox.discontinued.length + failBox.address.length + failBox.stopped.length + failBox.email.length}건:${
            failBox.discontinued
              ? '이미 이용 정지 중인 회원입니다.(' + failBox.discontinued.toString() + ')'
              : '' + failBox.address
              ? '이메일 주소가 없는 회원입니다.(' + failBox.address.toString() + ')'
              : '' + failBox.stopped
              ? '이미 이용 정지 중인 회원입니다.(' + failBox.stopped.toString() + ')'
              : '' + failBox.email
              ? '이메일 주소가 없는 회원입니다.(' + failBox.email.toString() + ')'
              : ''
          }`;
        }

        if (res.data) {
          let successIndex = 0;
          let failIndex = 0;
          let errorBox = '';
          let successMessage = '';
          let failMessage = '';
          let rowLength= res.data.rows.length;
          res.data.rows.map(item => {
            if (item.success) {
              successIndex++;
              successMessage = `성공${successIndex}건:이용정지 완료`;
            } else {
              failIndex++;
              if (failIndex === rowLength) {
                errorBox += item.memberNo;
              } else {
                errorBox += item.memberNo + ',';
              }
              
              failMessage = `실패${failIndex}건: ${item.message}(${errorBox})`;
            }
          });
          if (successIndex) {
            alert(successMessage + failMessage);
          } else {
            alert(failMessage);
          }
          $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback as string}()`);
          window.close();
        } else {
        }
      });
      return true;
    } else {
      return false;
    }
  }
  private cancel(): void {
    window.close();
  }
  private updated(): void {
    if (this.stopValue === 'RELIEVE_STOP') {
      this.placeholderValue = this.$t('MEMBER_POPUP_PLACE_HOLDER_VALUE') as string;
      this.validPeriod = 'RELIEVE_STOP';
    } else if (this.stopDateValue === 'PERMANENT_STOP') {
      this.validPeriod = 'PERMANENT_STOP';
    } else {
      this.validPeriod = '';
      if (this.placeholderValue === '이용 정지 해제는 고객알림이 발송되지 않습니다.') {
        this.placeholderValue = '';
      }
    }
  }
}
